import React, { useEffect, useState } from "react";
import Loading from "../../common-components/Loader";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchIsbnList, resetIsbnPage } from "../../redux/reducers/ISBNSReducer";
import { OptionType } from "../TMM/commonInterfaceTypes";
import {
  checkAuthorization,
  emptyDetailsPageRecord,
  FetchDetailsRecord,
  setDetails,setAuthorized,
  currentController
} from "../../redux/reducers/DetailPageReducer";
import { base64ToBlobAndURL } from "../../common-components/commonFunctions";
import SelectedTitleDetails from "./modules/SelectedTitleDetails";
import SelectInput from "../../common-components/CustomSelect";
import SalesDetails from "./modules/salesDetails";
import { emptyTitleListSalesRecord } from "../../redux/reducers/titleListSalesReducer";
import PosSales from "./modules/PosSales";
import InventorySalesContainer from "./modules/InventorySalesContainer";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { clearYTDData } from "../../redux/reducers/titleListYTDSalesReducer";
import { clearMTDData } from "../../redux/reducers/titleListMTDSalesReducer";
import { clearLTDData } from "../../redux/reducers/titleListLTDSalesReducer";
import { clearInventorySales } from "../../redux/reducers/titleListInventorySalesReducer";
import { emptyBookscanPosSales as emptyAmazonPosSales } from "../../redux/reducers/titleListAmazonReducer";
import { emptyBookscanPosSales as emptyBookScanPosSales } from "../../redux/reducers/titleListBookscanSalesReducer";
import { RLSApi } from "../../redux/reducers/TitleListreducer";
import { user } from "../../redux/reducers/UserReducer";
import Alogo from "../../assets/images/logo.png";
export interface TitleDetailsFormValues {
  isbn: OptionType | null;
  title: OptionType | null;
}

const TitleDetails: React.FC = () => {
  const isFirefox =
    typeof navigator !== "undefined" && navigator.userAgent.includes("Firefox");
  const { control, watch, setValue } = useForm<TitleDetailsFormValues>();
  const [imageSrc, setImageSrc] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const isbnReducer = useSelector((state: RootState) => state.isbnReducer);
  const titleSalesisLoading = useSelector(
    (state: RootState) => state.titleSalesReducer.isLoading
  );
  const YTDSales = useSelector((state: RootState) => state.titleSalesYTDReducer);
  const MTDSales = useSelector((state: RootState) => state.titleSalesMTDReducer);
  const LTDSales = useSelector((state: RootState) => state.titleSalesLTDReducer);
    const authorized = useSelector((state: RootState) => state.detailPageReducer.authorized);
const loading=useSelector((state:RootState)=>state.detailPageReducer.loading)

  const tabs = [
    { id: "bookDetails", label: "Book Details" },
    { id: "sales", label: "Sales" },
    { id: "pos", label: "POS" },
    { id: "inventory", label: "Inventory" },
  ] as const;

  const [searchParams] = useSearchParams();
  const initialTab =
    (searchParams.get("tab") as (typeof tabs)[number]["id"]) ?? tabs[0].id;

  const [activeTab, setActiveTab] = useState<(typeof tabs)[number]["id"]>(
    initialTab
  );


  const params = useParams();
  const navigate = useNavigate();

  const DetailData = useSelector(
    (state: RootState) => state.detailPageReducer.data
  );

  const DetailDataLoading = useSelector(
    (state: RootState) => state.detailPageReducer.isLoading
  );

  console.log(DetailDataLoading,'DetailDataLoading');

  const [isbn_number_options, setIsbn_number_options] = useState<OptionType[]>(
    []
  );

  const [isbn_title_options, setIsbn_title_options] = useState<OptionType[]>(
    []
  );
 const userData = useSelector(user);
  const rawData = useSelector((state: RootState) => state.TitleListreducer.dataOfRls);

  let dataofrls =
    rawData && rawData.length > 0 && rawData.some(v => v.VALUE)
      ? rawData
      : (rawData?.[0]?.COLUMN === "0" && rawData?.[0]?.VALUE === "0"
        ? rawData
        : null);

  const hasStar = dataofrls?.some(v => v.VALUE === "*");

  const column = hasStar ? null : dataofrls?.[0]?.COLUMN ?? null;

  const value = hasStar
    ? []
    : dataofrls
      ? dataofrls
        .flatMap(v =>
          v.VALUE
            ? v.VALUE.split(",").map((str: any) => str.trim()).filter(Boolean)
            : []
        )
      : [];

  useEffect(() => {


    if (userData?.email) {
      dispatch(RLSApi({ email: userData?.email, report_id: "4" }));
    }

  }, [dispatch, userData?.email]);


  useEffect(() => {

    console.log("value changed:", value);
        console.log("userData:", userData?.role.includes("Admin"));


    if(!userData?.role.includes("Admin")){

    if (userData && value[0] !== "0" && (params.id || watch("isbn")?.value)) {
      dispatch(
        checkAuthorization({
          column: column ?? "",
          isbn: params.id ? params.id : watch("isbn")?.value ?? "",
          value: Array.isArray(value)
            ? value
            : value
              ? [value]
              : []
        })
      );
    }
  }else{
    dispatch(setAuthorized("true"));
  }

  }, [dataofrls, watch("isbn")]);


 

 useEffect(() => {
    if (userData?.email) {
      dispatch(RLSApi({ email: userData?.email, report_id: "4" }));
    }
  }, [dispatch, userData?.email]);

  useEffect(() => {
     if(!userData?.role.includes("Admin")){
    if (userData && value[0] !== "0" && (params.id || watch("isbn")?.value)) {
      dispatch(
        checkAuthorization({
          column: column ?? "",
          isbn: params.id ? params.id : watch("isbn")?.value ?? "",
          value: Array.isArray(value)
            ? value
            : value
              ? [value]
              : []
        })
      );
    }
  }else{
    dispatch(setAuthorized("true"));
  }
  }, [dataofrls, watch("isbn")]);

 useEffect(() => {
    if (authorized == "false" && value[0] !== "0") {

    console.log("changeIsbnInfo event:11", authorized,value[0]);
 setValue("isbn", null);
      setValue("title", null);
      handleEmptyAll();
      dispatch(emptyDetailsPageRecord());
      dispatch(clearYTDData());
      dispatch(clearMTDData());
      dispatch(clearLTDData());
      dispatch(clearInventorySales())
navigate("/title-details");

    }
  }, [authorized, dataofrls]);

  const handleEmptyAll = () => {
    setImageSrc("");
    dispatch(emptyTitleListSalesRecord());
    dispatch(resetIsbnPage());
  };

  const clearAllTabData = () => {
    // Clear Book Details data
    dispatch(emptyDetailsPageRecord());
    // Clear Sales data
    dispatch(emptyTitleListSalesRecord());
    dispatch(clearYTDData());
    dispatch(clearMTDData());
    dispatch(clearLTDData());
    // Clear POS data
    dispatch(emptyAmazonPosSales());
    dispatch(emptyBookScanPosSales());
    // Clear Inventory data
    dispatch(clearInventorySales());
    // Clear form and image
    setImageSrc("");
    setValue("isbn", null);
    setValue("title", null);
  };

  // Clear all data when component unmounts (navigating away from page)
  useEffect(() => {
    return () => {
      clearAllTabData();
    };
  }, []);

  useEffect(() => {
    if (isbnReducer.isbns?.length) {

      setIsbn_title_options(
        isbnReducer.isbns
          .map((isbn: any) => {
            if (isbn.FULL_TITLE?.length > 1) {
              return {
                value: isbn._id ?? "",
                label: isbn.FULL_TITLE ?? "",
              };
            }
            return undefined;
          })
          .filter((option): option is OptionType => option !== undefined)
      );

      setIsbn_number_options(
        isbnReducer.isbns
          .map((isbn: any) => {
            if (isbn.ISBN?.length > 1) {
              return {
                value: isbn._id ?? "",
                label: isbn.ISBN ?? "",
              };
            }
            return undefined;
          })
          .filter((option): option is OptionType => option !== undefined)
      );
    }
  }, [isbnReducer.isbns]);

 useEffect(() => {
    // if (isbnReducer.isbnPage > 1 || !isbnReducer.isbns?.length || isbnReducer.isbnsString?.length) {

    if(value[0] !== "0"){
    dispatch(
      fetchIsbnList({
        oldEans: isbnReducer.isbns.map((isbn) => isbn._id),
        isbns: isbnReducer.isbns,
        limit: isbnReducer.isbnLimit,
        page: isbnReducer.isbnPage,
        prevIsbns: isbnReducer.selectedISBNS,
        isbnString: isbnReducer.isbnsString,
        column,
        ...(Array.isArray(value) && !value.includes("0") ? { value } : {})
      })
    
    );
  }
    // }
  }, [isbnReducer.isbnPage, isbnReducer.isbnsString,dataofrls,authorized]);

  const changeIsbnInfo = (event: any) => {
    // if (event.target.value) {
    //   if (event.target.name === "title") {
    //   const titleId = watch("title")?.value;
        const targetValue = event?.target?.value;

    const targetName = event?.target?.name;
  if (targetValue) {
      if (targetName === "title") {
        const titleId = targetValue?.value ?? watch("title")?.value;


              const filteredIsbn =
          isbn_number_options?.filter((isbn) => titleId === isbn.value) || [];

        if (filteredIsbn.length > 0) {
          const isbnOption: OptionType = {
            value: filteredIsbn[0].value || "",
            label: filteredIsbn[0].label || "",
          };
          setValue("isbn", isbnOption);
            if (isbnOption.value && params.id !== isbnOption.value) {
            navigate(`/title-details/${isbnOption.value}`);
          }
                  } else {
          // Handle case where no matching ISBN is found
          setValue("isbn", null);
           navigate("/title-details", { replace: true });
        }
      } else if (targetName === "isbn") {
        const isbnsId = targetValue?.value ?? watch("isbn")?.value;
        const titleFiltered =
          isbn_title_options?.filter((title) => isbnsId === title.value) || [];

        if (titleFiltered.length > 0) {
          const titleOption: OptionType = {
            value: titleFiltered[0].value || "",
            label: titleFiltered[0].label || "",
          };
          setValue("title", titleOption);
        } else {
          setValue("title", null);
         navigate("/title-details", { replace: true });
        }
        

        if (isbnsId && params.id !== isbnsId) {
          navigate(`/title-details/${isbnsId}`);
        } else if (!isbnsId) {
          navigate("/title-details", { replace: true });
        }
      }
    } else {
      handleEmptyAll();
      dispatch(emptyDetailsPageRecord());
      dispatch(clearYTDData());
      dispatch(clearMTDData());
      dispatch(clearLTDData());
      dispatch(clearInventorySales());
      setValue("isbn", null);
      setValue("title", null);
      // Remove ISBN from URL when cleared
      if (params.id) {
        navigate("/title-details", { replace: true });
      }
    }
  };

  useEffect(() => {
    if (DetailData._id && DetailData.EAN?.length) {
      if (!watch("isbn")?.value && !watch("title")?.value) {
        setValue("isbn", {
          value: DetailData._id ?? "",
          label: DetailData.EAN ?? "",
        });
        setValue("title", {
          value: DetailData._id ?? "",
          label: DetailData.FULL_TITLE ?? "",
        });
      }
      const fetchImageUrl = async () => {
        if (
          JSON.stringify(DetailData.imageBase64String) === "404" ||
          DetailData.imageBase64String?.length
        ) {
          const url = await base64ToBlobAndURL(DetailData.imageBase64String);
          setImageSrc(url);
        }
      };
      fetchImageUrl();
    }
  }, [DetailData]);
useEffect(() => {
    if (authorized == "true") {
      if (watch("isbn")?.value) {
        dispatch(
          setDetails(
            watch("isbn") && watch("isbn")?.value
              ? watch("isbn")?.value
              : params.id
          )
        );
        dispatch(
          FetchDetailsRecord({
            id:
              watch("isbn") && watch("isbn")?.value
                ? watch("isbn")?.value
                : params.id
                  ? params.id
                  : null,
            isbn: watch("isbn")?.label ?? null,
          })
        );
      }
    }
    return () => {
    if (currentController) {
      currentController.abort();
    }
  };
  }, [watch("isbn"), authorized]);
  // useEffect(() => {
  //   if (watch("isbn")?.value) {
  //     dispatch(
  //       setDetails(
  //         watch("isbn") && watch("isbn")?.value
  //           ? watch("isbn")?.value
  //           : params.id
  //       )
  //     );
  //     dispatch(
  //       FetchDetailsRecord({
  //         id:
  //           watch("isbn") && watch("isbn")?.value
  //             ? watch("isbn")?.value
  //             : params.id
  //               ? params.id
  //               : null,
  //         isbn: watch("isbn")?.label ?? null,
  //       })
  //     );
  //   }
  // }, [watch("isbn")]);

  // useEffect(() => {
  //   if (params.id) {
  //     dispatch(
  //       setDetails(
  //         watch("isbn") && watch("isbn")?.value
  //           ? watch("isbn")?.value
  //           : params.id
  //       )
  //     );
  //     dispatch(
  //       FetchDetailsRecord({
  //         id:
  //           watch("isbn") && watch("isbn")?.value
  //             ? watch("isbn")?.value
  //             : params.id
  //               ? params.id
  //               : null,
  //       })
  //     );
  //   }
  // }, [params.id]);

   useEffect(() => {
    if (params.id && authorized == "true") {
      const isbnValue = watch("isbn")?.value || params.id;
      dispatch(
        setDetails(isbnValue)
      );
      dispatch(
        FetchDetailsRecord({
          id: isbnValue,
          isbn: watch("isbn")?.label || params.id || null,
        })
      );
      
    }
    return () => {
    if (currentController) {
      currentController.abort();
    }
  };
  }, [params.id, authorized]);
  return (
    <div className="flex flex-col gap-2 overflow-y-auto">
      <div className="w-full">
        <div className="flex items-center w-full px-1 py-1 gap-2 mb-1">
          <div className="flex justify-between items-center bg-gradient-to-r from-red-500 flex-1 px-3 py-2 text-[20px] font-bold text-white rounded-md">
            Title Details
            <img src={Alogo} alt="" className="w-6 h-6 ml-2" />
          </div>
        </div>
      </div>
      <div className="overflow-y-auto h-[82vh] px-4">
        <Loading
          isLoading={
            loading ||
            DetailDataLoading ||
            titleSalesisLoading ||
            isbnReducer.isLoading ||
            YTDSales.isLoading ||
            MTDSales.isLoading ||
            LTDSales.isLoading
          }
        >
          <div className="py-2 flex gap-4">
            {activeTab !== "bookDetails" && (
              <div className="flex items-center">
                <div className="w-[140px] h-[180px] border border-gray-200 rounded-lg overflow-hidden flex items-center justify-center bg-white">
                  {imageSrc?.length ? (
                    <img
                      src={imageSrc}
                      alt="Book cover"
                      className="object-cover w-full h-full"
                    />
                  ) : (
                    <span className="text-xs text-gray-400 text-center px-2">
                      No Cover
                    </span>
                  )}
                </div>
              </div>
            )}

            <div className="flex-1 flex flex-col gap-4">
              <div className="grid grid-cols-1 lg:grid-cols-6 gap-4 items-end  w-full">
                <div className="w-full">
                  <p className="text-[#e31c23] font-bold">ISBN</p>
                  <div className="w-full grid grid-cols-1 bg-white rounded-lg">
                    <SelectInput
                      control={control}
                      name="isbn"
                      options={isbn_number_options}
                      placeholder="Select ISBN"
                      onChangeCallback={changeIsbnInfo}
                      watch={watch}
                      isFirefox={isFirefox}
                      hasMoreIsbn={isbnReducer.hasMoreIsbn}
                      copyBtn={true}
                    />
                  </div>
                </div>
                 <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">AUTHOR</p>
                            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData.AUTHOR_1?.length > 1 ? DetailData.AUTHOR_1 : "—"}
                            </div>
                        </div>
                <div className="w-full">
            <p className="text-[#e31c23] font-bold text-xs mb-1">FORMAT</p> 
            <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                {DetailData?.FORMAT?.length > 1 ? DetailData.FORMAT : "—"}
            </div>
        </div>
                <div className="w-full">
    <p className="text-[#e31c23] font-bold text-sm mb-1">IMPRINT</p>
    <div className="border-[1px] h-[40px] overflow-x-auto overflow-y-hidden whitespace-nowrap border-gray-300 rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
      {DetailData?.TESTIMPRINTFROMHNA?.length > 1 ? DetailData.TESTIMPRINTFROMHNA : "—"}
    </div>
  </div>
              <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">BISAC STATUS</p>
                            <div className="border-[1px] h-[40px] border-gray-300 overflow-x-auto overflow-y-hidden whitespace-nowrap rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.BISAC_STATUS || "—"}
                            </div>
                       </div>
                        <div className="w-full">
                            <p className="text-[#e31c23] font-bold text-xs mb-1">PARENT ISBN</p>
                            <div className="border-[1px] h-[40px] border-gray-300 overflow-x-auto overflow-y-hidden whitespace-nowrap rounded-lg w-full p-2 bg-white flex items-center text-sm font-medium">
                                {DetailData?.PARENT_ISBN || "—"}
                            </div>
                        </div>
                        {/* 🟩 CHANGE THIS DIV LINE BELOW */}
<div className="w-full lg:col-span-6">
  <p className="text-[#e31c23] font-bold">TITLE</p>
  <div className="w-full grid grid-cols-1 bg-white rounded-lg">
    <SelectInput
      control={control}
      name="title"
      options={isbn_title_options}
      placeholder="Select Book Title"
      onChangeCallback={changeIsbnInfo}
      watch={watch}
      isFirefox={isFirefox}
      hasMoreIsbn={isbnReducer.hasMoreIsbn}
      copyBtn={true}
    />
  </div>
</div>
              </div>

              <div className="flex gap-0 border-b border-gray-200 justify-start">
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      className={`px-6 py-2 rounded-t-lg border border-b-0 transition-colors text-sm ${
                        isActive
                          ? "bg-red-50 text-gray-900 border-gray-200 font-semibold"
                          : "bg-white text-gray-600 border-transparent hover:bg-gray-100"
                      }`}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="mt-0">
            {activeTab === "bookDetails" && (
              <>
                <SelectedTitleDetails
                  DetailData={DetailData}
                  imageSrc={imageSrc}
                />
                {/* <div className="w-full p-10 border-[4px] my-10 border-gray-300 flex flex-col items-center justify-center">
                  <p className="font-bold">Additional Data</p>
                  <p className="font-bold text-red-600">Coming Soon</p>
                </div> */}
              </>
            )}

            {activeTab === "sales" && (
              <SalesDetails 
                selectedIsbn={watch("isbn")?.label}
                selectedIsbnOption={watch("isbn")}
                selectedTitleOption={watch("title")}
                DetailData={DetailData}
              />
            )}

            {activeTab === "pos" && (
              <PosSales
                selectedIsbnOption={watch("isbn")}
                selectedTitleOption={watch("title")}
              />
            )}

            {activeTab === "inventory" && (
              <InventorySalesContainer
                selectedIsbn={
                  watch("isbn")?.label || DetailData.EAN || params.id || null
                }
                selectedIsbnOption={watch("isbn")}
                selectedTitleOption={watch("title")}
                imageSrc={imageSrc}
                control={control}
                watch={watch}
                isbnNumberOptions={isbn_number_options}
                isbnTitleOptions={isbn_title_options}
                changeIsbnInfo={changeIsbnInfo}
                isFirefox={isFirefox}
                hasMoreIsbn={isbnReducer.hasMoreIsbn}
              />
            )}
          </div>
        </Loading>
      </div>
    </div>
  );
};

export default TitleDetails;